import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "delete"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "This action is irreversible.", -1)
const _hoisted_3 = { class: "cta-section flex flex-row gap-3 justify-content-end" }
const _hoisted_4 = {
  key: 1,
  class: "delete-pending"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Deleting...", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "delete-complete"
}
const _hoisted_8 = { class: "cta-section flex flex-row gap-3 justify-content-end" }

import { watch } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import { DeleteChannelPayload } from '@/models/channel-list.model';
import Button from 'primevue/button';
  

export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChannelDelete',
  props: {
    props: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();
const emit = __emit;

const props = __props

function onDelete(){
  if(guildStore.guild){
    const payload = new DeleteChannelPayload({
      guildId: guildStore.guild.id,
      groupId: props.props.channelGroupId,
      channelId: props.props.channelId
    });
    guildStore.deleteChannel(payload);
  } else {
    console.error('Cannot delete channel, guild not found');
  }
}

function closeOnDeleted(){
  emit('close');
}

watch(() => apiStatusStore.requestFulfilled('delete_channel'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Channel succesfully deleted')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('delete_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              label: "Cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }),
            _createVNode(_unref(Button), {
              label: "Delete",
              onClick: onDelete,
              disabled: _unref(apiStatusStore).requestPending('delete_channel')
            }, null, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('delete_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('delete_channel'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: closeOnDeleted
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})